import { db } from "../../firebaseConfig";
import "./PrivacyToggle.css";

import { doc, updateDoc } from "firebase/firestore";

const PrivacyToggle = ({
  userId,
  privacy,
  setPrivacy
}) => {

  const isPublic = privacy === "public";

  const handleToggle = async () => {
    try {

      const newPrivacy =
        privacy === "public"
          ? "private"
          : "public";

      await updateDoc(
        doc(db, "users", userId),
        {
          privacy: newPrivacy
        }
      );

      setPrivacy(newPrivacy);

    } catch (err) {
      console.error("Privacy update failed:", err);
    }
  };

  return (
    <button
      className={`privacy-btn ${isPublic ? "public" : "private"}`}
      onClick={handleToggle}
    >

      <span className="lock-icon">
        {isPublic ? "🔓" : "🔒"}
      </span>

      <span>
        {isPublic ? "Public" : "Private"}
      </span>

    </button>
  );
};

export default PrivacyToggle;